import React, { useCallback, useMemo } from 'react';
import { Button, Tag, Text } from 'src/@vymo/ui/atoms';
import { Card } from 'src/@vymo/ui/blocks';
import classnames from 'classnames';
import { ReactComponent as Selected } from 'src/assets/icons/active.svg';
import { ReactComponent as ArrowRight } from 'src/assets/icons/arrowRight.svg';
import { ReactComponent as Completed } from 'src/assets/icons/completed.svg';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { useAppDispatch } from 'src/store/hooks';
import { setLobCode } from '../slice';
import { init } from '../thunk';
import Attributes from './attributes';
import { LobProps } from './types';
import styles from './index.module.scss';

function NavLob({
  title,
  button_title,
  progress_tag,
  lob_code,
  last_completed_action,
  next_action,
  attributes,
  vo = '',
  isCompleted = false,
}: LobProps) {
  const dispatch = useAppDispatch();
  const isEntityPayloadDisabled = getGrowthBookFeatureFlag(
    'disable-entity-payload',
  );
  const onNavigateToLob = useCallback(() => {
    dispatch(init({ lobCode: isEntityPayloadDisabled ? lob_code : vo }));
    dispatch(setLobCode(isEntityPayloadDisabled ? lob_code : vo));
  }, [dispatch, isEntityPayloadDisabled, lob_code, vo]);

  const leadTags = useMemo(
    () => (
      <div className={styles.lob__lead_tags}>
        {last_completed_action && (
          <div className={styles.lob__lead_tags__item}>
            <Completed />
            <Text semiBold>Last Completed : &nbsp;</Text>
            <Text>{last_completed_action}</Text>
          </div>
        )}
        {next_action && (
          <div className={styles.lob__lead_tags__item}>
            <Selected />
            <Text semiBold>Next Step : &nbsp;</Text>
            <Text>{next_action}</Text>
          </div>
        )}
      </div>
    ),
    [last_completed_action, next_action],
  );
  const lobClass = classnames(styles.lob, {
    [styles.lob__completed_application]: isCompleted,
  });
  return (
    <Card classNames={lobClass}>
      <Text semiBold>{title}</Text>
      {progress_tag && <Tag>{progress_tag}</Tag>}
      {leadTags}
      <Attributes attributes={attributes} />
      <Button
        className={styles.lob__applicationButton}
        type="outlined"
        rounded
        size="medium"
        iconProps={{
          icon: <ArrowRight />,
          iconPosition: 'right',
        }}
        onClick={onNavigateToLob}
      >
        {button_title || 'Start Application'}
      </Button>
    </Card>
  );
}

export default NavLob;
